// extracted by css-extract-rspack-plugin
export default {"headerHeight":"66px","spaceXSmall":"8px","size60":"60px","header":"header__header___doDyx","logo":"header__logo___KNw1W"};